import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { useDevice } from '@/app/hooks';

const DynamicPreviewVideo = dynamic(() => import('./PreviewVideo'), { ssr: false });

interface VideoCardProps {
  videoUrl: string;
  posterUrl: string;
}
export const VideoCard: FC<VideoCardProps> = ({ videoUrl, posterUrl }) => {
  const { supportsHover } = useDevice();

  return (
    <div className="group cursor-pointer rounded-8">
      <div className="relative aspect-video w-full overflow-hidden rounded-8 group-hover:bg-system-bg02">
        {supportsHover ? (
          <DynamicPreviewVideo videoUrl={videoUrl} posterUrl={posterUrl}>
            <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-b from-[77.57%] from-transparent to-[100%] to-black/60" />
          </DynamicPreviewVideo>
        ) : (
          <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-b from-[60%] from-transparent to-[100%] to-black/60">
            <img src={posterUrl} className="h-full w-full object-contain" alt="video poster" />
          </div>
        )}
      </div>
    </div>
  );
};
